module.exports = __webpack_public_path__ + "fonts/DM_Sans-200-latin-ext4.49935c4.woff2";